"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationField = void 0;
var core_1 = require("@material-ui/core");
var React = __importStar(require("react"));
var react_1 = require("react");
var defaultLabelsEn_json_1 = __importDefault(require("./defaultLabelsEn.json"));
var DurationField = function (_a) {
    var duration = _a.duration, onConfirm = _a.onConfirm, _b = _a.TextFieldComp, TextFieldComp = _b === void 0 ? core_1.TextField : _b, view = _a.view, _labels = _a.labels, props = __rest(_a, ["duration", "onConfirm", "TextFieldComp", "view", "labels"]);
    var labels = __assign(__assign({}, defaultLabelsEn_json_1.default), _labels);
    var _c = (0, react_1.useState)(duration[view]), value = _c[0], setValue = _c[1];
    (0, react_1.useEffect)(function () {
        setValue(duration[view]);
    }, [duration, setValue]);
    return (React.createElement(TextFieldComp
    // type="number"
    , __assign({ 
        // type="number"
        onChange: function (_a) {
            var target = _a.target;
            var num = +target.value;
            setValue(!isFinite(num) || target.value === '' ? undefined : num);
        }, onBlur: function () {
            onConfirm(value);
        }, value: value !== null && value !== void 0 ? value : '', fullWidth: true, label: labels[view] }, props)));
};
exports.DurationField = DurationField;
